export class MapEvents {
    static get mouseOverArbetsorder(): string { return "productionplanning_map_mouseOverArbetsorder"; }
    static get mouseOverAtgard(): string { return "productionplanning_map_mouseOverAtgard"; }
    static get select(): string { return "productionplanning_map_select"; }
    static get selectMulti(): string { return "productionplanning_map_selectMulti"; }
    static get selectAll(): string { return "productionplanning_map_selectAll"; }
    static get showOnlySelected(): string { return "productionplanning_map_showOnlySelected"; }
    static get selectArbetsorder(): string { return "productionplanning_arbetsorder_select"; }
    static get selectArbetsordrar(): string { return "productionplanning_arbetsordrar_select"; }
    static get addAtgardToArbetsorder(): string { return "productionplanning_atgard_added"; }
    static get arbetsorderExtentUpdated(): string { return "arbetsorder_extent_updated"; }
    static get arbetsorderUpdated(): string { return "arbetsorder_updated"; }
    static get virkeskopGeometriUpdated(): string { return "virkeskop_geometri_updated"; }
    static get atgardGeometriUpdated(): string { return "atgard_geometri_updated"; }
    static get atgardGeometriRemoved(): string { return "atgard_geometri_removed"; }
    static get atgardGeometriCreated(): string { return "atgard_geometri_created"; }
    static get geometriUpdated(): string { return "productionplanning_geometri_updated"; }
    static get geometriRemoved(): string { return "productionplanning_geometri_removed"; }
    static get geometriMenuHover(): string { return "productionplanning_geometri_menu_hover"; }
    static get geometriMenuSelected(): string { return "productionplanning_geometri_menu_selected"; }
    static get importFastighetsuppgifter(): string { return "import_fastighetsuppgifter"; }
    static get kontraktUpdated(): string { return "kontrakt_updated"; }
    static get arbetsorderAfterSave(): string { return "arbetsorder_aftersave"; }
    static get setArbetsorderList(): string { return "arbetsorder_set_list"; }
    static get arbetsorderDeleted(): string { return "productionplanning_arbetsorder_deleted"; }
    static get mapPan(): string { return "productionplanning_map_pan"; }
    // tillfällig lösning för gamla VK, kan städas bort i framtiden
    static get virkeskopSaved(): string { return "virkeskop_saved"; }
}
